import { useQuery } from '@tanstack/react-query';
import { apiGet } from '../../../api';

export function useStorageInventory() {
  return useQuery(['storageInventory'], async () => {
    try {
      const apiResult = await apiGet(`storage/inventory?v=${Date.now()}`);
      if (apiResult.ok) {
        return apiResult.json();
      }

      throw new Error('Unable to fetch inventory');
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
      return null;
    }
  });
}
